import { Person } from '../objects/Person';
import * as _ from 'lodash';

angular.module("tromanWeb").factory('PersonState', ['$q', 'tromanServer', 'ObjectCache', 'dialogService', function ($q, tromanServer, ObjectCache, dialogService) {

    function PersonState() {
    }

    PersonState.create = function (personId) {
        return getPerson(personId)
            .then(loadRelated)
            .then(loaded)
            .catch(err => {
                dialogService.error(err);
                return $q.reject(err);
            });
    };

    function getPerson(personId) {
        if (personId) {
            return tromanServer.Persons.get(personId);
        } else {
            return $q.when(new Person());
        }
    }

    function loadPhoto(person) {
        let photo = person.ProfilePhoto;
        if (photo != null) {
            return tromanServer.Files.downloadAttachment(photo.Id).then(dlr => {
                return dlr.asDataUrl().then(durl => ({
                    data: durl,
                    info: photo,
                }));
            });
        } else {
            return $q.when(null);
        }
    }

    function loadRelated(person) {
        return $q.all({
            person: $q.when(person),
            photo: loadPhoto(person),
            parties: ObjectCache.getParties(person.Party),
            divisions: ObjectCache.getDivisions(person.Division),
            systemSettings: tromanServer.System.getSettings(),
        });
    }

    function loaded(data) {
        var ret = new PersonState();

        angular.extend(ret, data);

        if (!data.person.Id) {
            data.person.HasMeetingPay = true;
            data.person.HasPolitikerAccess = data.systemSettings.DefaultPersonPolitikerAccess;
            data.person.Publish = _.cloneDeep(data.systemSettings.DefaultPersonPublish);
        }

        return ret;
    }

    return PersonState;

}]);
